<div>
  <mat-checkbox
    color="primary"
    [(ngModel)]="task.isChecked"
    (ngModelChange)="selectTask()"
    [disabled]="task.isNotSelectable"
    [matTooltip]="'inbox/message/action/checkbox' | translate"
    [matTooltipDisabled]="task.isNotSelectable"></mat-checkbox>
</div>
